import { type Term, TermType } from "@onestore/api/types"
import isEmpty from "~/lib/isEmpty"

type GroupedTermsData = {
  allGroupedTerms: Term[]
  groupedTermsWithoutHiddens: Term[]
  separatedTerms: Term[]
}

export const getGroupedTerms = (
  terms: Term[],
  groupedTermsHiddenIds?: {
    termId: number
  }[]
): GroupedTermsData => {
  const groupedTermsHiddenIdsList: number[] = !isEmpty(groupedTermsHiddenIds)
    ? groupedTermsHiddenIds.map((term) => term.termId)
    : []

  const allGroupedTerms = terms.filter(
    (term) =>
      term.type === TermType.EXTERNAL ||
      groupedTermsHiddenIdsList.includes(term.id)
  )

  const groupedTermsWithoutHiddens = allGroupedTerms.filter(
    (term) => !groupedTermsHiddenIdsList.includes(term.id)
  )

  const separatedTerms = terms.filter((term) => {
    const isInGroupedTerms = !!allGroupedTerms.find(
      (groupedTerm) => groupedTerm.id === term.id
    )

    return !isInGroupedTerms
  })

  return { allGroupedTerms, groupedTermsWithoutHiddens, separatedTerms }
}
